var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED8808",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.243 1.906v1.672C8.01 3.93 7.109 5.052 7.109 6.372s.924 2.442 2.134 2.816v8.162c0 .44.352.814.814.814.44 0 .814-.352.814-.814V9.188c1.232-.352 2.134-1.474 2.134-2.794S12.103 3.952 10.87 3.6V1.928a.812.812 0 0 0-.814-.814.78.78 0 0 0-.814.792zm2.134 4.466c0 .704-.572 1.32-1.32 1.32-.748 0-1.32-.572-1.32-1.32 0-.748.572-1.32 1.32-1.32.748 0 1.32.616 1.32 1.32zM4.425 17.35v-1.738c1.232-.352 2.134-1.474 2.134-2.794s-.902-2.442-2.134-2.794V1.906a.812.812 0 0 0-.814-.814.799.799 0 0 0-.814.814v8.118c-1.232.352-2.134 1.474-2.134 2.794s.902 2.442 2.134 2.794v1.738c0 .44.352.814.814.814a.799.799 0 0 0 .814-.814zM2.29 12.818c0-.704.572-1.32 1.32-1.32.748 0 1.32.572 1.32 1.32 0 .748-.616 1.32-1.32 1.32-.704 0-1.32-.616-1.32-1.32zM15.689 1.906v8.118c-1.232.352-2.134 1.474-2.134 2.794s.902 2.442 2.134 2.794v1.738c0 .44.352.814.814.814a.799.799 0 0 0 .814-.814v-1.738c1.232-.352 2.134-1.474 2.134-2.794s-.902-2.442-2.134-2.794V1.906a.812.812 0 0 0-.814-.814.799.799 0 0 0-.814.814zm2.134 10.912c0 .704-.572 1.32-1.32 1.32-.748 0-1.32-.572-1.32-1.32 0-.748.572-1.32 1.32-1.32.748 0 1.32.616 1.32 1.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bae1d2438ed1299284d2a36316fd243c.svg";
export { ForwardRef as ReactComponent };